import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './main-card.scss.js';

class MainCard extends s {
    render() {
        return x `<div class="main-card"><div class="main-card-container"><slot></slot></div></div>`;
    }
}
MainCard.styles = css_248z;
customElements.define('main-card', MainCard);

export { MainCard };
